import { DOCUMENT_TYPE_CODES } from '../../constants/documentTypeCodes';

import { mapCreditFiscalSale } from './creditFiscalMapper';
import { mapCreditNoteSale } from './creditNoteMapper';
import { mapConsumerInvoiceSale } from './consumerInvoiceMapper';
import { mapExportInvoiceSale } from './saleExportInvoiceMapper';

export const SaleMappers = {
  [DOCUMENT_TYPE_CODES.TAX_CREDIT]: mapCreditFiscalSale,
  [DOCUMENT_TYPE_CODES.CREDIT_NOTE]: mapCreditNoteSale,
  [DOCUMENT_TYPE_CODES.INVOICE]: mapConsumerInvoiceSale,
  [DOCUMENT_TYPE_CODES.EXPORT_INVOICE]: mapExportInvoiceSale,
};
